import { EVENTS } from "../APIs/APIs";
import axios from "axios";
import { toast } from "react-toastify";
import { setCookies, getCookie } from "./auth";

export function loginHasError(data) {
  return {
    type: EVENTS.LOGIN_HAS_ERRORS,
    data,
  };
}

export function loginInProgress(data) {
  return {
    type: EVENTS.LOGIN_IN_PROGRESS,
    data,
  };
}

export function loginIsDone(data) {
  return {
    type: EVENTS.SET_USER_AUTHENTICATION,
    data,
  };
}

export function loginFetchedToken(data) {
  return {
    type: EVENTS.SET_USER_TOKEN,
    data,
  };
}

export function loginFetchedRefreshToken(data) {
  return {
    type: EVENTS.SET_USER_REFRESH_TOKEN,
    data,
  };
}

export function loginFetchedUserInfo(data) {
  return {
    type: EVENTS.SET_USER_INFO,
    data,
  };
}

export function loginAsync(params) {
  return (dispatch) => {
    dispatch(loginInProgress(true));

    axios({
      method: "post",
      url: params.url,
      data: params.data,
    })
      .then((res) => {
        const serviceResult = res.data;
        if (res.data.status === 200 && serviceResult.status == 200) {
          if (!serviceResult.data.succeeded) {
            dispatch(loginInProgress(false));
            toast.error(serviceResult.data.messages[0].message);
            return;
          }
          setCookies("token", res.data.token);
          setCookies("refreshToken", res.data.refreshToken);
          dispatch(loginInProgress(false));
          //dispatch(loginFetchedToken(res.data.token));
          //dispatch(loginFetchedRefreshToken(res.data.refreshToken));
          dispatch(loginFetchedUserInfo(res.data.data.result));
          dispatch(loginIsDone(true));
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${res.data.token}`;
        } else {
          // toast.error("خطا در برقراری ارتباط با شبکه");
        }
      })
      .catch(() => {
        dispatch(loginInProgress(false));
        dispatch(loginHasError(true));
      });
  };
}
